import {
  BibliographyTagRegisterData,
  BibliographyTagRegisterDataToJSON
} from '@/api/models'

export interface BibliographyRealUpdateRequest {
  details: BibliographyTagRegisterData[]
  revision: number
}

export function BibliographyRealUpdateRequestToJSON(
  value: BibliographyRealUpdateRequest
): any {
  return {
    details: value.details.map(BibliographyTagRegisterDataToJSON),
    revision: value.revision
  }
}
